import numberMixin from "@/mixins/numberMixin";

const inCents = value => numberMixin.methods.currencyInCents(value);

function buildUpdateWalletRequestBody(payload) {
  return {
    data: {
      type: "wallets",
      id: payload.id,
      attributes: {
        blocked: inCents(payload.balance.blocked)
      }
    }
  };
}

export default { buildUpdateWalletRequestBody };



// WEBPACK FOOTER //
// ./src/API/helpers/wallets.js